export const getForbiddenReason = (headers: unknown): string | null => {
  if (!headers || typeof headers !== 'object') {
    return null;
  }

  const key = 'x-forbidden-reason';

  if ('get' in headers && typeof (headers as { get: unknown }).get === 'function') {
    const value = (headers as { get(k: string): unknown }).get(key);

    return typeof value === 'string' ? value : null;
  }

  const value = (headers as Record<string, unknown>)[key];

  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.find((v): v is string => typeof v === 'string') ?? null;

  return null;
};
